import SEO from "components/seo";
import Layout from "components/layout";
import MedicalTranslation from "components/reusableComponents/MedicalTranslation/index";
import React from "react";

function index() {
  const title = "Professional Medical translation services";
  const description =
    "High quality Medical translation services by professional Medical translators. Tomedes provides the best Medical translation quotes. Get the best combination of low cost, high quality and fast delivery Medical translation services from Tomedes.";
  const keywords =
    "medical translation, professional medical translation, medical translation quote";
  const slug = "/medical-translation.php";
  return (
    <Layout>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        slug={slug}
      />
      <MedicalTranslation />
    </Layout>
  );
}

export default index;
